export default __webpack_public_path__ + "static/g1-1b9ddc2532d6a351d211f101dc9c3745.jpg";